import React from 'react'
import {
    OverContainerSection,
    OverContainer,
    OverSpan,
    ContentTypography,
    Back,
} from './styles'
import { SectionProps } from 'src/pages'
import BackButton from 'src/components/common/BackButton/BackButton'

export const Header = ({ success }: SectionProps) => {
    return (
        <OverContainerSection background={success.background}>
            <OverContainer
                paddingBottom={['medium', 'medium', 'large', 'titlle']}
                width={1}
                image={success.cover}
                id={success.title}
            >
                <OverSpan></OverSpan>
                <Back marginTop={['xxmall', 'xxmall', 'xxmall', 'xsixty']}>
                    <BackButton />
                </Back>
                <ContentTypography
                    marginTop={['medium', 'medium', 'medium', 'xsixty']}
                ></ContentTypography>
            </OverContainer>
        </OverContainerSection>
    )
}
